export default "__VITE_ASSET__CUygLAe2__"